import { combineReducers } from '@reduxjs/toolkit';

import account from './account';
import cookbook from './cookbook';
import dashboard from './dashboard';
import dismissals from './dismissals';
import grace from './grace';
import homepage from './homepage';
import mealFilters from './mealFilters';
import meals from './meals';
import menuSearch from './menuSearch';
import messageCenter from './messageCenter';
import messages from './messages';
import promotions from './promotions';
import recommendedMeals from './recommendedMeals';
import restartCampaign from './restartCampaign';
import sendABox from './sendABox';
import shoppingList from './shoppingList';
import user, * as fromUser from './user';
import userOffers from './userOffers';
import v3Homepage from './v3/homepage';

export default combineReducers({
  account,
  cookbook,
  dashboard,
  dismissals,
  grace,
  homepage,
  mealFilters,
  meals,
  messages,
  messageCenter,
  recommendedMeals,
  shoppingList,
  user,
  userOffers,
  promotions,
  restartCampaign,
  menuSearch,
  sendABox,
  v3: combineReducers({
    homepage: v3Homepage,
  }),
});

export const selectUser = state => state.user;
export const selectUserLoadingStatus = state => fromUser.selectUserStatus(selectUser(state));
export const selectMealAddonSelections = state =>
  fromUser.selectMealAddonSelections(selectUser(state));
export const selectOptInSelections = state => fromUser.selectOptInSelections(selectUser(state));
export const selectExperimentAssignment = (state, experimentName) =>
  fromUser.selectExperimentAssignment(selectUser(state), experimentName);
export const selectUserInviteCode = state => fromUser.selectUserInviteCode(selectUser(state));
export const selectUserAddresses = state => fromUser.selectUserAddresses(selectUser(state));
export const selectCurrentMenuSlug = state => fromUser.selectCurrentMenuSlug(selectUser(state));
